import { fetchWithAuth } from './client';
async function request(path, body) {
  const result = await fetchWithAuth(`/json/gifts${path}`, body ? { method: 'POST', body } : {});
  if (result.error) throw new Error(result.message || 'Unable to load this gift.');
  return result.data;
}
export const giftsApi = {
  catalog: () => request('/catalog'),
  list: before => request(before ? `?before=${encodeURIComponent(before)}` : ''),
  checkout: requestKey => request('/checkout', { requestKey }),
  status: id => request(`/${encodeURIComponent(id)}`),
  preview: code => request('/preview', { code }),
  redeem: code => request('/redeem', { code }),
};
